import React,{useState,useEffect} from 'react';

import DataTableAttendanceEvent from '../../components/datatable/DataTableAttendanceEvent';
import {useTranslation} from 'react-i18next';
import * as RestService from '../../services/eisRest';
import * as moment from 'moment';




const  AttendanceEventDatatable = (props) => {

    const [t] = useTranslation();     
    
    const [checkTime, setCheckTime] = useState(null);
    const tableName = t('attendance.label.attendanceEventList'); 


    const approvedStatus = (row) => {
        let approvedText = "";
        let approvedColor = "";
        if(row.id!==null){
            switch(row.approved){
                case 1:
                    approvedText="Schvaluje sa...";
                    approvedColor = "#FFA500";
                break;
                case 2:
                    approvedText="Schválený";
                    approvedColor = "#228B22";
                break;
                case 3:
                    approvedText="Zamietnutý";
                    approvedColor = "#FF0000";
                break;
                default:
                    approvedText="";
                    approvedColor = "";
            }
        }
        
        return (<>
                    <span style={{"color": approvedColor}}>
                        {approvedText}
                    </span>
                </>);
       
    }

    const columns = [       
        { name: "Id", data: "id", selector: "id", omit: true},
        { name: t('attendance.label.code'),  selector: "attendanceCode.code",        
        cell:(row) => row.id ?  t('attendance.label.'+row.attendanceCode.code) : ""},
        { name: t('attendance.label.start'),  selector: "start",
        cell:(row) => row.id ?  moment(row.start).format("DD.MM.YYYY HH:mm") : ""},
        { name: t('attendance.label.stop'),  selector: "stop",
        cell:(row) => row.id ?  moment(row.stop).format("DD.MM.YYYY HH:mm") : ""},
        { name: t('attendance.label.time'),  selector: "intervalText"},
        { name: t('general.label.description'),   selector: "description"},
        { name: t('attendance.label.sourceOfEvents'),  sortable: false, selector: "sourceOfEvent"},
        { name: t('attendance.label.approved'),  sortable: false, selector: "approved",
            cell:(row) => approvedStatus(row)}
    
    ];    
 

    const columnsData = [       
        { name: "Id", data: "id", searchable: false, orderable: false, search: {value: '',regex: false}},
        { name:  t('attendance.label.code'), data: "attendanceCode.code",  orderable: true, searchable: true, search: {value: '',regex: false}},    		
        { name: t('attendance.label.start'), data: "start", orderable: true,  searchable: true, search: {value: '',regex: false}},
        { name: t('attendance.label.stop'), data: "stop", orderable: true,  searchable: true, search: {value: '',regex: false}},
        { name: t('attendance.label.time'), data: "intervalText", orderable: true,  searchable: true, search: {value: '',regex: false}},
        { name: t('general.label.description'), data: "description", orderable: true,  searchable: true, search: {value: '',regex: false}}
     
    ];    
            
     const url = RestService.getBaseURL()+"attendance/getAttendanceEventList?attendanceDetailId="+props.entityId;   
     const urlExcel = RestService.getBaseURL()+"";          
    
   
 

     const handleCallback  = (id) => {
             props.parentCallback(id);                   
     };
   
     useEffect(() => {      
        setCheckTime(props.checkTime);
      }, [props.checkTime])


    
         return (
           
             <DataTableAttendanceEvent
                 url={url}  
                 urlExcel={urlExcel}  
                 tableName={tableName}
                 columns={columns}   
                 columnsData={columnsData}
                 parentCallback={handleCallback}
                 modalShow={props.modalShow}
                 exportShow={false}
                 checkTime={checkTime}
             />
           
         );
    
 
  
 };

export default AttendanceEventDatatable;

